export default __webpack_public_path__ + "static/media/help_sub-photo_sample2.477407a8.png";